import { getCookie, setCookie, deleteCookie } from "cookies-next";

const base = process.env.NEXT_PUBLIC_API_URL;

async function handleRefreshToken(accessToken, refreshToken) {
  const res = await fetch(`${base}/client/customer/refresh-token`, {
    method: "POST",
    body: JSON.stringify({ accessToken, refreshToken }),
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) throw new Error("Failed to refresh token");

  const data = await res.json();

  if (data?.isError || data?.code === 401) {
    deleteCookie("accessToken");
    deleteCookie("refreshToken");
    return null;
  }

  setCookie("accessToken", data?.data?.accessToken);
  setCookie("refreshToken", data?.data?.refreshToken);
  return data;
}

async function fetchWithAuth(method, path, body, options = {}) {
  const token = getCookie("accessToken");
  const refreshToken = getCookie("refreshToken");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(options.headers || {}),
  };

  const res = await fetch(base + path, {
    method,
    body: body ? JSON.stringify(body) : undefined,
    headers,
    ...options,
  });

  const json = await res.json();

  if (json.code === 401 && token && refreshToken) {
    const refreshed = await handleRefreshToken(token, refreshToken);
    if (refreshed) {
      return fetchWithAuth(method, path, body, options);
    }
  }

  return json;
}

export const apiClient = {
  get: (path, options) => fetchWithAuth("GET", path, undefined, options),
  post: (path, body, options) => fetchWithAuth("POST", path, body, options),
  put: (path, body, options) => fetchWithAuth("PUT", path, body, options),
  patch: (path, body, options) => fetchWithAuth("PATCH", path, body, options),
  del: (path, options) => fetchWithAuth("DELETE", path, undefined, options),
};
